"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ApiKeys = /*#__PURE__*/function () {
  function ApiKeys(registry, _ref) {
    var parentRoutes = _ref.parentRoutes;
    (0, _classCallCheck2["default"])(this, ApiKeys);
    this._api = registry;
    this._parentRoutes = parentRoutes;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(ApiKeys, [{
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(entityId, id) {
        var _routeParams;

        var entityIdRoute, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                entityIdRoute = this._parentRoutes.get;
                _context.next = 3;
                return this._api.GetAPIKey({
                  routeParams: (_routeParams = {}, (0, _defineProperty2["default"])(_routeParams, entityIdRoute, entityId), (0, _defineProperty2["default"])(_routeParams, "key_id", id), _routeParams)
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getById(_x, _x2) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(entityId, params) {
        var entityIdRoute, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entityIdRoute = this._parentRoutes.list;
                _context2.next = 3;
                return this._api.ListAPIKeys({
                  routeParams: (0, _defineProperty2["default"])({}, entityIdRoute, entityId)
                }, params);

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadListResponse('api_keys', result));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAll(_x3, _x4) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(entityId, key) {
        var entityIdRoute, result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                entityIdRoute = this._parentRoutes.create;
                _context3.next = 3;
                return this._api.CreateAPIKey({
                  routeParams: (0, _defineProperty2["default"])({}, entityIdRoute, entityId)
                }, _objectSpread({}, key));

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function create(_x5, _x6) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(entityId, id) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.updateById(entityId, id, {
                  rights: []
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteById(_x7, _x8) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(entityId, id, patch) {
        var _routeParams4;

        var mask,
            entityIdRoute,
            result,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                mask = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.UpdateAllowedFieldMaskPaths);
                entityIdRoute = this._parentRoutes.update;
                _context5.next = 4;
                return this._api.UpdateAPIKey({
                  routeParams: (_routeParams4 = {}, (0, _defineProperty2["default"])(_routeParams4, entityIdRoute, entityId), (0, _defineProperty2["default"])(_routeParams4, 'api_key.id', id), _routeParams4)
                }, {
                  api_key: _objectSpread({}, patch),
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 4:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function updateById(_x9, _x10, _x11) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }]);
  return ApiKeys;
}();

var _default = ApiKeys;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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